// Detect and split a "Revenue Potential" string that contains an extreme
// (>50x) low-to-high range. Returns { typical, top } when the range is wide,
// or null when the original string is fine to show as-is.
//
// Example input:  "$1K to $200K per month"
// Example output: { typical: "$1K to $10K per month", top: "$200K per month" }
export function splitRevenueRange(text) {
  if (!text || typeof text !== "string") return null;
  const m = text.match(
    /\$([\d.,]+)\s*([KkMm]?)\s*(?:to|-|–|—)\s*\$([\d.,]+)\s*([KkMm]?)/,
  );
  if (!m) return null;

  const toNum = (n, u) => {
    const x = parseFloat(String(n).replace(/,/g, ""));
    if (!isFinite(x)) return null;
    const unit = (u || "").toLowerCase();
    const mult = unit === "k" ? 1_000 : unit === "m" ? 1_000_000 : 1;
    return x * mult;
  };

  const low = toNum(m[1], m[2]);
  const high = toNum(m[3], m[4]);
  if (!low || !high || high / low <= 50) return null;

  // Trailing context like "/ month", "per month", "monthly"
  const tail = text.slice(m.index + m[0].length).trim();

  const fmtAmt = (n) => {
    if (n >= 1_000_000) {
      const v = n / 1_000_000;
      return `$${Number.isInteger(v) ? v : v.toFixed(1)}M`;
    }
    if (n >= 1_000) {
      const v = n / 1_000;
      return `$${Number.isInteger(v) ? v : v.toFixed(1)}K`;
    }
    return `$${Math.round(n)}`;
  };

  // "Typical" upper = 10x low (a realistic operator band)
  const typicalHigh = low * 10;

  return {
    typical: `${fmtAmt(low)} to ${fmtAmt(typicalHigh)}${tail ? " " + tail : ""}`,
    top: `${fmtAmt(high)}${tail ? " " + tail : ""}`,
  };
}
